/**
 * Reviewer Prompts
 *
 * Review and quality check prompts for evaluating content.
 *
 * @module config/prompts/reviewer-prompts
 */
// ═══════════════════════════════════════════════════════════════════════════
// REVIEWER PROMPTS
// ═══════════════════════════════════════════════════════════════════════════
export const REVIEWER_STYLE_CHECK = {
    id: 'REVIEWER_STYLE_CHECK',
    name: 'Reviewer Style Consistency Check',
    description: 'Evaluate text style against persona',
    template: `Analyze this text's style{{#if persona}} compared to the persona "{{persona}}"{{/if}}.

{{#if voiceTraits}}
Persona voice traits: {{voiceTraits}}
{{/if}}

Evaluate:
- Voice consistency with persona traits
- Formality level appropriateness
- Pattern usage (contractions, rhetorical questions)
- AI tell presence

Text:
{{content}}

Respond with JSON:
{
  "styleScore": 0.0-1.0,
  "voiceMatch": 0.0-1.0,
  "formalityMatch": 0.0-1.0,
  "aiTellsDetected": ["Tell description"],
  "issues": ["Issue description"]
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['reviewer'],
};
export const REVIEWER_STRUCTURE_CHECK = {
    id: 'REVIEWER_STRUCTURE_CHECK',
    name: 'Reviewer Structure Analysis',
    description: 'Analyze chapter structural quality',
    template: `Analyze this chapter's structure:
- Opening: Does it hook the reader?
- Body: Is it well-organized with clear sections?
- Transitions: Are section bridges smooth?
- Conclusion: Does it provide satisfying closure?

Chapter:
{{content}}

Respond with JSON:
{
  "structureScore": 0.0-1.0,
  "openingQuality": 0.0-1.0,
  "transitionQuality": 0.0-1.0,
  "conclusionQuality": 0.0-1.0,
  "issues": ["Issue description"]
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0.3,
        maxTokens: 1024,
    },
    version: 1,
    usedBy: ['reviewer'],
};
export const REVIEWER_FACT_EXTRACTION = {
    id: 'REVIEWER_FACT_EXTRACTION',
    name: 'Reviewer Fact Claim Extraction',
    description: 'Extract verifiable factual claims',
    template: `Extract verifiable factual claims from this text.

For each claim:
- claim: The factual statement
- location: Where in text
- verifiable: Can it be fact-checked?

Text:
{{content}}

Respond with JSON:
{
  "claims": [
    {
      "claim": "The factual statement",
      "location": "Beginning/middle/end or quote",
      "verifiable": true/false
    }
  ]
}`,
    requirements: {
        capabilities: ['json-mode'],
        temperature: 0,
        maxTokens: 2048,
    },
    version: 1,
    usedBy: ['reviewer'],
};
export const REVIEWER_PROMPTS = [
    REVIEWER_STYLE_CHECK,
    REVIEWER_STRUCTURE_CHECK,
    REVIEWER_FACT_EXTRACTION,
];
//# sourceMappingURL=reviewer-prompts.js.map